import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const SPINNER_OVERLAY_COMPONENT_TYPE: InjectionToken<ComponentType<unknown>> =
  new InjectionToken<ComponentType<unknown>>('spinnerOverlayComponentType');
